import {
  PROFIT_AND_LOSS_STATEMENT_DATA_FROM_DATE_RANGE_SENT,
  PROFIT_AND_LOSS_STATEMENT_DATA_FROM_DATE_RANGE_SUCCESS,
  PROFIT_AND_LOSS_STATEMENT_DATA_FROM_DATE_RANGE_ERROR,
} from "./actionType";

const initialState = {
  profitAndLossStatementDataFromDateRange: [],
  profitAndLossStatementDataFromDateRangeError: null,
  profitAndLossStatementDataFromDateRangeLoading: false,
};

const ProfitAndLoss = (state = initialState, action) => {
  switch (action.type) {
    case PROFIT_AND_LOSS_STATEMENT_DATA_FROM_DATE_RANGE_SENT:
      return {
        ...state,
        profitAndLossStatementDataFromDateRangeLoading: true,
      };
    case PROFIT_AND_LOSS_STATEMENT_DATA_FROM_DATE_RANGE_SUCCESS:
      return {
        ...state,
        profitAndLossStatementDataFromDateRange: action.payload,
        profitAndLossStatementDataFromDateRangeLoading: false,
      };
    case PROFIT_AND_LOSS_STATEMENT_DATA_FROM_DATE_RANGE_ERROR:
      return {
        ...state,
        profitAndLossStatementDataFromDateRangeError: action.payload,
        profitAndLossStatementDataFromDateRangeLoading: false,
      };
    default:
      return state;
  }
};

export default ProfitAndLoss;
